export default "__VITE_ASSET__CfOMl9G8__"